// The reason a request failed, in words: the server's own message when it sent one,
// otherwise the status code or the connection problem. Never an empty "Error".
export default function errorReason(err) {
  const data = err?.response?.data;
  const fromServer = typeof data === 'string'
    ? data
    : data?.result || data?.detail || data?.error || data?.title || data?.message;
  const text = fromServer
    || (err?.response ? `The server answered with an error (${err.response.status}).` : '')
    || (err?.code === 'ECONNABORTED' ? 'The request took too long.' : '')
    || (err?.message === 'Network Error' ? 'Could not reach 2Check. Check the Wi-Fi.' : '')
    || err?.message
    || 'Unknown error.';
  const oneLine = String(text).replace(/\s+/g, ' ').trim();
  return oneLine.length > 300 ? `${oneLine.slice(0, 300)}…` : oneLine;
}
